/**
 * Centralized copy for the read-only Subscriptions tab inside Customer
 * Information (abo-subscriptions-tab). Kept out of the component per the repo
 * rule that feature text is not hardcoded inline (mirrors
 * MemberBooksTab.strings.ts). Placeholders use `{token}` and are filled with
 * the same `formatMessage` helper as the Book Access tab.
 */
export { formatMessage } from "./MemberBooksTab.strings";

export const memberSubscriptionsStrings = {
  tabTitle: "Subscriptions",
  readOnlyCaption:
    "Read-only. Billing changes (cancel, reactivate, change plan) are made in Chargebee.",
  none: "—",
  loadError: "Could not load this member's subscriptions. Please try again.",
  retry: "Try again",
  empty: "No subscription record in DS",
  planFromChargebee: "Plan read from Chargebee: the DS record has no plan.",
  notices: {
    chargebeeUnavailable:
      "Showing DS data only; Chargebee could not be reached. Live billing details are missing.",
    chargebeeNotFound:
      "This subscription was not found in Chargebee. Showing DS data only.",
    drift:
      "DS and Chargebee disagree on: {fields}. Check Chargebee before answering the member.",
    driftFields: {
      status: "status",
      plan: "plan",
      customer: "Chargebee customer",
    },
    driftFieldSeparator: ", ",
    resignupHint:
      "If the member re-subscribed, the new subscription may be missing from DS. Check the member's customer in Chargebee.",
  },
  current: {
    heading: "Current subscription",
    noCurrent: "No current subscription in DS.",
    unknownPlan: "Unknown plan",
    status: "Status",
    trialEnd: "Trial end",
    currentPeriod: "Current period",
    periodRange: "{start} – {end}",
    trialPeriodRange: "Trial: {start} – {end}",
    nextBilling: "Next billing",
    cancellation: "Cancellation",
    cancelsOn: "Cancels on",
    cancelledOn: "Cancelled on",
    created: "Created",
    price: "Price",
    priceWithPeriod: "{price} / {period}",
    billingPeriodSingle: "{unit}",
    billingPeriodMultiple: "{count} {unit}s",
    openSubscription: "Open subscription in Chargebee",
    openCustomer: "Open customer in Chargebee",
  },
  history: {
    heading: "Subscription history ({count})",
    statusAsRecorded: "as recorded",
    legacy: "Legacy (Chargify)",
    created: "Created",
    termEnd: "Term end",
    cancellation: "Cancellation",
    openSubscription: "Open subscription in Chargebee",
  },
} as const;
